const botPageContent = {
  "afterparty-groovy": {
    categories: ["Music", "Entertainment"],
    bestFor: "Communities that want continuous music, playlists, and a shared listening experience.",
  },
  "guardian-link": {
    categories: ["Moderation", "Security", "Automation"],
    bestFor: "Networked communities that need shared moderation intelligence and audit-ready security workflows.",
  },
  versa: {
    categories: ["Moderation", "Utility", "Automation"],
    bestFor: "Growing communities that need structured moderation, roles, automation, and analytics in one bot.",
  },
  verifybot: {
    categories: ["Moderation", "Verification", "Security"],
    bestFor: "Age-gated and community-focused servers that need reliable verification and trusted-access controls.",
  },
  "voice-maestro": {
    categories: ["Utility", "Voice Automation"],
    bestFor: "Servers that want temporary voice rooms created automatically as members need them.",
    docsUrl: "https://voicemaestro.xyz/",
  },
  "lofi-vibes": {
    categories: ["Music", "Entertainment"],
    bestFor: "Study rooms, relaxed communities, and members who want curated lofi music around the clock.",
  },
  kitsubot: {
    categories: ["Fun", "Community", "Utility"],
    bestFor: "Anime-themed communities that want social commands, reactions, games, and lighthearted utilities.",
  },
  novapulse: {
    categories: ["Moderation", "Verification", "Security", "Automation"],
    bestFor: "Community servers, gaming communities, and growing Discord servers.",
  },
};

export default botPageContent;